/**
 * Removes duplicates from a list based on a key function.
 */
export function dedupe<T>(list: T[], keyFn: (item: T) => unknown = (item) => item) {
  const seen = new Set();

  return list.filter((item: T) => {
    const key = keyFn(item);

    const duplicate = seen.has(key);

    seen.add(key);

    return !duplicate;
  });
}
